import { SeriesParticipant } from '../types';

export function collectRaceIds(participants: SeriesParticipant[]): string[] {
  const races = new Set<string>();
  participants.forEach((p) => {
    Object.keys(p.races || {}).forEach((id) => races.add(id));
  });
  return Array.from(races).sort();
}

export function applyBestOf(
  participants: SeriesParticipant[],
  bestOfCount?: number
): SeriesParticipant[] {
  return participants.map((participant) => {
    const races = participant.races || {};
    const totalPoints = Object.values(races).reduce((sum, race) => sum + (race?.points || 0), 0);
    if (bestOfCount) {
      const bestRaces = Object.entries(races)
        .sort(([, a], [, b]) => b.points - a.points)
        .slice(0, bestOfCount);
      return {
        ...participant,
        races,
        totalPoints,
        bestRaces: bestRaces.map(([id]) => id),
        bestOfPoints: bestRaces.reduce((sum, [, race]) => sum + race.points, 0),
      };
    }
    return {
      ...participant,
      races,
      totalPoints,
      bestRaces: Object.keys(races),
      bestOfPoints: totalPoints,
    };
  });
}

export function effectivePoints(participant: SeriesParticipant): number {
  return participant.bestOfPoints || participant.totalPoints || 0;
}
